<template>
  <div class="boxtitle roundedblu">
    Overview
  </div>
  <el-row class="mx-5 mt-3">
    The Open Access Hub provides complete, free and open access to GF-1, GF-2,
    and GF-6 user products.
  </el-row>
  <el-row class="mx-5 mt-3"><h1>GF-1 Data Offer</h1></el-row>
  <el-row class="mx-5 mt-3"
    >The GF-1 data offer for the Open Access Hub will consist of Level-1 and
    Level-2 user products.</el-row
  >
  <el-row class="mx-5 mt-3"><h1>GF-2 Data Offer</h1></el-row>
  <el-row class="mx-5 mt-3"
    >The GF-1 data offer for the Open Access Hub will consist of Level-1 and
    Level-2 user products.</el-row
  >
  <el-row class="mx-5 mt-3"><h1>GF-6 Data Offer</h1></el-row>
  <el-row class="mx-5 mt-3"
    >The GF-1 data offer for the Open Access Hub will consist of Level-1 and
    Level-2 user products.</el-row
  >

  <el-row class="mx-5 mt-3"><h1>Free and Open data access</h1></el-row>
  <el-row class="mx-5 mt-3 left-align"
    >Anyone can register online via self-registration. The self-registration
    process is automatic and immediate. Registration grants access rights for
    searching and downloading GF products. GF products are
    available at no cost for anybody. </el-row
  >
</template>

<style scoped>
.boxtitle {
  margin: 5px !important;
  color: white !important;
  text-align: left;
}
.roundedblu {
  background: #1e364e;
  color: #fff;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  font-family: "NotesEsaRegular";
  font-size: 22px;
  padding: 15px;
  overflow: auto;
}
.left-align {
  text-align: left;
  font-family: "NotesEsaRegular" !important;
}
</style>
